import { render, staticRenderFns } from "./OutroScreen.vue?vue&type=template&id=522ab244&scoped=true&"
import script from "./OutroScreen.vue?vue&type=script&lang=js&"
export * from "./OutroScreen.vue?vue&type=script&lang=js&"
import style0 from "./OutroScreen.vue?vue&type=style&index=0&id=522ab244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ab244",
  null
  
)

export default component.exports